import {
    Card,
    Container,
    Typography,
    styled,
  } from "@mui/material";
  import { useTranslation } from "react-i18next";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";
  
  const RollersGuide: React.FC = () => {
    const { t } = useTranslation();
    
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    const CustomCard = styled(Card)({
      borderRadius: 10,
      marginBottom: "12px",
      backgroundColor: "whitesmoke",
      padding: "20px"
    });
  
    const CustomTypography = styled(Typography)({
      margin: 8,
      fontFamily: "monospace",
      letterSpacing: "0.8px",
      color: "#29ADB2",
      fontWeight: "400",
      fontSize: "18px",
      whiteSpace: "pre-line"
    });
  
    const TitleTypography = styled(Typography)({
      fontSize: "30px",
      color: "rgb(32, 119, 190)"
    });
  
    return (
      <Container>
        <HeaderCard text={t("presentation.rollers.detail.description")} />
        <CustomCard>
          <TitleTypography>
            {t("presentation.rollers.detail.fitness.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.rollers.detail.fitness.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.rollers.detail.speed.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.rollers.detail.speed.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.rollers.detail.aggressive.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.rollers.detail.aggressive.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.rollers.detail.freestyle.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.rollers.detail.freestyle.description")}
          </CustomTypography>
        </CustomCard >
      </Container>
    );
  };
  
  export default RollersGuide;
  